import { styled } from '@linaria/react';

import { hoverable } from '~theme/snippets';

export const NSFWModeSwitchContainer = styled.button`
	padding: 2px 6px 2px 8px;
	display: flex;
	gap: 6px;
	background-color: var(--color-white-01);
	justify-content: center;
	align-items: center;
	border-radius: 12px;
	height: 24px;

	${hoverable};

	@media screen and (min-width: 1580px) {
		position: absolute;
		left: 50%;
	}

	@media screen and (max-width: 1580px) and (min-width: 769px) {
		margin-right: auto;
		margin-left: auto;
	}

	p {
		color: var(--color-white-05);
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
	}
`;
